/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/admins/adminsActions";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { CreateAdminForm } from "./CreateAdminForm";
import { AdminEditForm } from "./AdminEditForm";
import { EditProfile } from "./EditProfile";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";

const initAdmin = {
  id: undefined,
  name: "",
  email: "",
  password: "",
};
	
	

export function AdminEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const {user} = useSelector(state => state.auth);
  const userData = user.userData;
  const userid = userData.userid;
  // Subheader
  const suhbeader = useSubheader();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, adminForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.admins.actionsLoading,
      adminForEdit: state.admins.adminForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchAdmin(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New Admin";
    if (adminForEdit && id) {_title = `${adminForEdit.name} Edit Profile`;}
	
	setTitle(_title);
    suhbeader.setTitle(_title);
	
	if(userid===id){	suhbeader.setTitle(`Edit Profile`);setTitle(`${userData.name}`);}
	// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminForEdit, id]);

  const saveAdmin = (values) => {
    if (!id) {
      dispatch(actions.createAdmin(values)).then(() => backToAdminsList());
    } else {
      dispatch(actions.updateAdmin(values)).then(() => backToAdminsList());
    }
  };

  const btnRef = useRef();  
  const saveAdminClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToAdminsList = () => {
    navigate(`/admin`);
  };
  var editprofile_flag = 0;
  if(userid===id){ editprofile_flag=1;}
  
  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type="button"
            onClick={backToAdminsList}
            className="btn btn-light"
          >
            <i className="fa fa-arrow-left"></i>
            Back
          </button>
          {`  `}
          <button
            type="submit"
            className="btn btn-primary ml-2"
            onClick={saveAdminClick}
          >
            Save
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <ul className="nav nav-tabs nav-tabs-line " role="tablist">
          <li className="nav-item" onClick={() => setTab("basic")}>
            <a
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle="tab"
              role="tab"
              aria-selected={(tab === "basic").toString()}
            >
              Basic info
            </a>
          </li>
          
		  
		  
        </ul>
        <div className="mt-5">
          
		  {tab === "basic" && editprofile_flag===0 && id &&(
            <AdminEditForm
              actionsLoading={actionsLoading}
              admin={adminForEdit || initAdmin}
              btnRef={btnRef}
              saveAdmin={saveAdmin}
            />
          )}
		  
		  {tab === "basic" && editprofile_flag===1 && id &&(
            <EditProfile
              actionsLoading={actionsLoading}
              admin={adminForEdit || initAdmin}
              btnRef={btnRef}
              saveAdmin={saveAdmin}
            />
          )}
		  
		  {tab === "basic" && !id && (
            <CreateAdminForm
              actionsLoading={actionsLoading}
              admin={adminForEdit || initAdmin}
              btnRef={btnRef}
              saveAdmin={saveAdmin}
            />
          )}
		 
		  
        </div>
      </CardBody>
    </Card>
  );
}
